import {createReducer} from '@reduxjs/toolkit';
import {cleanChangeRequests} from 'src/modules/change-requests/services/actions';
import {getAllChangeRequestsSuccess} from 'src/openapi/apis/ChangeRequestControllerApi';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';

type State = {
    data: Array<ChangeRequest>,
};

const defaultState = {
    data: [],
};

export const changeRequests = createReducer<State>(defaultState, builder => builder
    .addCase(getAllChangeRequestsSuccess, (state, action) => {
        state.data = action.payload.data;
    })
    .addCase(cleanChangeRequests, state => {
        state.data = [];
    }),
);
